export const languages = {
    en: {
        nativeName: 'English',
        englishName: 'English',
    },
    fr: {
        nativeName: 'Français',
        englishName: 'French',
    },
};

export const languageOptions = Object.keys(languages).map((code) => ({
    label: languages[code].nativeName,
    value: code,
}));
